import { Box, Card, CardMedia, Typography, Divider } from "@mui/material";
import { CSSProperties } from "react";
import TopImage from "../assets/images/homepage-top.jpg";
import { MainLayout } from "../components/Layouts/MainLayout";

const mainContent: CSSProperties = {
    marginTop: "80px",
    maxWidth: "1150px",
    marginLeft: "auto",
    marginRight: "auto",
    // position: "absolute",
    // color: "white",
    // top: "40%",
    // left: "50%",
    // transform: "translateX(-50%)",
    // width: "100%",
    // textAlign: "left",
    // verticalAlign: "middle",
    // marginTop: "auto",
    // marginBottom: "auto",
};

const TermsPage = () => {
    return (
        <MainLayout>
            <Card>
                <Box style={{ position: "relative" }}>
                    {/* <CardMedia style={{}} component="img" image={TopImage} /> */}
                    <Box style={mainContent}>
                        <Typography variant="header02">
                            Nrby Events Terms and Conditions
                        </Typography>
                        <Typography variant="subheader02">
                            Last Updated: April 14, 2025
                        </Typography>
                        <Typography paragraph>
                            These Terms of Service (“Terms”) govern your access to and use of the website (www.nrbyevents.com), mobile application, and ticketing services (collectively, the “Services”) provided by Nrby Events, Inc. (“we,” “us,” “our”), as needed, to connect Users with events (“Events”) in the United States. By accessing, browsing, or using the Services, you acknowledge that you have read, understood, and agree to be bound by these Terms, our Privacy Policy (www.nrbyevents.com/privacy), Community Guidelines (www.nrbyevents.com/community), and, for Organizers, our Organizer Agreement (www.nrbyevents.com/organizer-agreement), collectively the “Nrby Agreements,” as needed, forming a binding contract. If you do not agree, please do not access, browse, or use the Services.
                            IMPORTANT NOTICE: Section 14 contains a binding arbitration provision and class action waiver that may affect your legal rights, requiring most claims to be resolved by arbitration on an individual basis, not in court or as part of a class action. Please read it carefully.
                        </Typography>
                        <Typography variant="h5" gutterBottom mt={4}>
                            1. About Nrby Events
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            1.1. Service Description
                        </Typography>
                        <Typography paragraph>
                            The Services are designed to provide a platform for Users to coordinate, plan, and engage with Attendees of Events in the United States, as needed. Organizers use the Services to create Event listings, sell tickets, and manage Attendees, while Attendees use the Services to discover, register for, and purchase tickets to Events, as needed. The Services include our website (www.nrbyevents.com), mobile application, and related technologies, encompassing all features, functionality, and updates, as needed.
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            1.2. Our Role
                        </Typography>
                        <Typography paragraph>
                            Nrby Events, Inc., located at 1161 Wayzata Blvd E., Suite 172, Wayzata, MN 55391, provides tools for Organizers to manage Events and for Attendees to access them. We are not the creator, owner, or operator of Events, nor the seller of tickets, unless expressly stated, as needed. Organizers are solely responsible for their Events, including compliance with laws and delivery of promised goods or services, as needed.
                        </Typography>

                        <Typography variant="h5" gutterBottom mt={4}>
                            2. Accepting These Terms
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            2.1. Eligibility
                        </Typography>
                        <Typography paragraph>
                            To use the Services, you must, as needed:
                            <ul>
                                <li>Be at least 18 years old or the age of majority in your state of residence.</li>
                                <li>Provide accurate, current, and complete information, updating it as needed.</li>
                                <li>Have the authority to bind any entity you represent (e.g., your employer), in which case “you” refers to that entity.</li>
                                <li>If you are under 18, you are not authorized to use the Services, with or without registering, as needed.</li>
                            </ul>
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            2.2. Additional Terms
                        </Typography>
                        <Typography paragraph>
                            These Terms incorporate the Nrby Agreements, as needed. For Organizers, the Organizer Agreement applies to ticketing and marketing tools. No terms in purchase orders or similar forms apply unless expressly agreed in writing by us, as needed.
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            2.3. Modifications
                        </Typography>
                        <Typography paragraph>
                            We may revise these Terms at our discretion, as needed, posting updates at www.nrbyevents.com/terms with an updated “Last Updated” date. We will notify you of material changes via the Services, email to your registered address, or other reasonable means, as needed. Material changes take effect 30 days after notice; non-material changes are effective immediately. Continued use constitutes acceptance, as needed. If you do not agree to revised Terms, you must stop using the Services.
                        </Typography>

                        <Typography variant="h5" gutterBottom mt={4}>
                            3. Registration and Account Responsibilities
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            3.1. Registration Requirement
                        </Typography>
                        <Typography paragraph>
                            You must register with Nrby Events to access certain features of the Services (e.g., ticket purchases, Event management), as needed. To register, you must provide a valid cell phone number, to which we will send a one-time verification code. You must enter this code to complete registration, as needed.
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            3.2. Account Security
                        </Typography>
                        <Typography paragraph>
                            You may not share the verification code with others and are responsible for ensuring the security of your account, as needed. Notify us at support@nrby.io of any unauthorized access, as needed. You are liable for all activity under your account, including by authorized sub-users, as needed.
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            3.3. Data Governance
                        </Typography>
                        <Typography paragraph>
                            Registration data and all information provided are governed by our Privacy Policy (www.nrbyevents.com/privacy), as needed. You must provide accurate, current, and complete information, updating it at www.nrbyevents.com/account, as needed.
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            3.4. License to Use
                        </Typography>
                        <Typography paragraph>
                            Upon registration, we grant you a limited, non-exclusive, non-transferable, non-sublicensable, revocable license, as needed, to:
                            <ul>
                                <li>Browse the Services, search for Events, and purchase or register for tickets (Attendees).</li>
                                <li>Create Event listings, promote Events, and manage ticket sales (Organizers).</li>
                                <li>Your use must comply with these Terms, the Nrby Agreements, and all applicable U.S. laws, as needed.</li>
                            </ul>
                        </Typography>

                        <Typography variant="h5" gutterBottom mt={4}>
                            4. User Conduct
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            4.1. Responsibility for User Content
                        </Typography>
                        <Typography paragraph>
                            You are solely responsible for all code, video, images, information, data, text, software, music, sound, photographs, graphics, messages, and other materials (“content”) that you make available to Nrby Events, including by uploading, posting, publishing, responding to host questionnaires, or displaying (hereinafter, “upload(ing)”) via the Services or
                            by emailing, SMS messaging, or otherwise making available to other Users of the Services (collectively, “User Content”), as needed. Nrby Events has no liability for any User Content, as needed.
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            4.2. Prohibited Content and Uses
                        </Typography>
                        <Typography paragraph>
                            The following are examples of the kinds of content and/or uses that are illegal or prohibited by Nrby Events, as needed. Nrby Events reserves the right to investigate and take appropriate legal action against anyone who, in Nrby Events’ sole discretion, violates this provision, including removing the offending content from the Services, suspending or terminating the account of such violators, and reporting the violator to law enforcement authorities, as needed. Except as expressly authorized by Nrby Events in writing, you agree not to use the Services to:
                            
                            <br/><br/>4.2.1. Email, send SMS messages, or otherwise upload or make available any content that:Infringes or violates any intellectual property right, publicity right, other proprietary right, or privacy right of any party, as needed.
                            <ul>
                                <li>
                                    You do not have a right to upload under any law or under contractual or fiduciary relationships, as needed.
                                </li>
                                <li>
                                    Contains software viruses or any other computer code, files, or programs designed to interrupt, destroy, or limit the functionality of any computer software or hardware or telecommunications equipment, as needed.
                                </li>
                                <li>
                                    Poses or creates a privacy or security risk to any person, as needed.
                                </li>
                                <li>
                                    Constitutes unsolicited or unauthorized advertising, promotional materials, commercial activities and/or sales, “junk mail,” “spam,” “chain letters,” “pyramid schemes,” “contests,” “sweepstakes,” or any other form of solicitation, as needed.
                                </li>
                                <li>Is illegal in the applicable jurisdiction, including but not limited to:
                                    <ul>
                                        <li>Cannabis: Messages related to cannabis are not allowed in the United States as federal laws prohibit its sale, even though some states have legalized it. Similarly, messages related to CBD are not permissible in the United States, as certain states prohibit its sale. Prohibited messages include any message which relates to the marketing or sale of a cannabis product, regardless of whether or not those messages explicitly contain cannabis terms, images, or links to cannabis websites, as needed.
                                        </li>
                                        <li>Prescription Medication: Offers for prescription medication that cannot legally be sold over-the-counter are prohibited in the United States, as needed.
                                        </li>
                                        <li>Age- and Geographic-Specific Content: If you are sending messages in any way related to alcohol, firearms, gambling, tobacco, or other adult content, then more restrictions apply. You must ensure that no message recipient is younger than the legal age to purchase or engage with the age-restricted products or content based on where the recipient is located, as needed.
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    Is harmful, threatening, false, misleading, fraudulent, abusive, exploitative, harassing, tortious, excessively violent, defamatory, vulgar, obscene, pornographic, libelous, invasive of another’s privacy, discriminatory, hateful (including but not limited to any offensive comments that are connected to race, national origin, gender, sexual preference, or physical handicap or any communications that originate from a hate group), or otherwise objectionable, as needed.
                                </li>
                                <li>
                                    Is designed to intentionally evade filters, including but not limited to intentionally misspelled words or non-standard opt-out phrases which have been specifically created with the intent to evade detection or “snowshoeing,” which is defined as spreading similar or identical messages across multiple phone numbers with the intent or effect of evading unwanted messaging detection and prevention mechanisms, as needed.
                                </li>
                                <li>
                                    In the sole judgment of Nrby Events, is objectionable or which restricts or inhibits any other person from using or enjoying the Services, or which may expose Nrby Events or its Users to any harm or liability of any type, as needed.
                                </li>
                                <li>
                                    Interfere with or disrupt the Services or servers or networks connected to the Services, or disobey any requirements, procedures, policies, or regulations of networks connected to the Services, as needed.
                                </li>
                                <li>
                                    Violate any applicable local, state, national, or international law, or any regulations having the force of law, as needed.
                                </li>
                                <li>
                                    Impersonate any person or entity, or falsely state or otherwise misrepresent your affiliation with a person or entity, as needed.
                                </li>
                                <li>
                                    Solicit personal information from anyone under the age of 18, as needed.
                                </li>
                                <li>
                                    Download or make any copies of any information about other Users of the Services, or use any such information—except where such information is previously known to you or is publicly available—to communicate with Users of the Services outside the Services, as needed.
                                </li>
                                <li>
                                    Advertise or offer to sell or buy any goods or services for any business purpose that is not specifically authorized, as needed.
                                </li>
                                <li>
                                    Further or promote any criminal activity or enterprise or provide instructional information about illegal activities, as needed.
                                </li>
                                <li>
                                    Obtain or attempt to access or otherwise obtain any content or information through any means not intentionally made available or provided for through the Services, as needed.
                                </li>
                                <li>
                                    Circumvent, remove, alter, deactivate, degrade, or thwart any of the content protections, platform restrictions, or geographic restrictions applicable to the Services, including, but not limited to, limits on the number of invites you can make, limits on the number of text messages you can send, or privacy features including the ability to hide the guest list, as needed.
                                </li>
                                <li>
                                    Engage in or use any data mining, robots, scraping, or similar data gathering or extraction methods, as needed. If you are blocked by Nrby Events from accessing the Services (including by blocking your IP address), you agree not to implement any measures to circumvent such blocking (e.g., by masking your IP address or using a proxy IP address or virtual private network), as needed.
                                </li>
                            </ul>
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            4.3. Representations and Warranties for User Content
                        </Typography>
                        <Typography paragraph>
                            When you create and/or make available any User Content, you represent and warrant that, as needed:
                            <ul>
                                <li>
                                    The creation, distribution, transmission, public display, or performance, and the accessing, downloading, or copying of your User Content do not and will not infringe the proprietary rights, including but not limited to the copyright, patent, trademark, trade secret, or moral rights of any third party, as needed.
                                </li>
                                <li>
                                    You are the creator and owner of or have the necessary licenses, rights, consents, releases, and permissions to use and to authorize us, the Services, and other Users of the Services to use your User Content in any manner contemplated by the Services and these Terms, as needed.
                                </li>
                                <li>
                                    You have the written consent, release, and/or permission of each and every identifiable individual person in your User Content to use the name or likeness of each and every such identifiable individual person to enable inclusion and use of your User Content in any manner contemplated by the Services and these Terms, as needed.
                                </li>
                            </ul>
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            4.4. Competitors
                        </Typography>
                        <Typography paragraph>
                            No employee, independent contractor, agent, or affiliate of any competing event planning or ticketing platform company is permitted to view, access, or use any portion of the Services without express written permission from Nrby Events, as needed. By viewing, using, or accessing the Services, you represent and warrant that you are not a competitor of Nrby Events or any of its affiliates, or acting on behalf of a competitor of Nrby Events in using or accessing the Services, as needed.
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            4.5. Commercial Use
                        </Typography>
                        <Typography paragraph>
                            Unless specifically authorized by Nrby Events in writing, you agree the Services are for personal use only and you will not display, distribute, license, perform, publish, reproduce, duplicate, copy, create derivative works from, modify, sell, resell, grant access to, transfer, or otherwise use or exploit any portion of the Services for any commercial purposes or to promote or market any product or service (including products or services of other Users), as needed.
                        </Typography>

                        <Typography variant="h5" gutterBottom mt={4}>
                            5. Using the Services
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            5.1. Restrictions
                        </Typography>
                        <Typography paragraph>
                            You agree not, directly or indirectly:
                            <ul>
                                <li>
                                    Reverse-engineer, decompile, or attempt to discover the source code or algorithms of the Services or related software (“Software”), as needed.
                                </li>
                                <li>
                                    Modify, translate, or create derivative works based on the Services or Software, except as permitted by us as needed.
                                </li>
                                <li>
                                    Use the Services for unauthorized commercial purposes or in violation of our Community Guidelines, as needed.
                                </li>
                                <li>
                                    Interfere with or disrupt the Services (e.g., via viruses, scraping, bots), as needed.
                                </li>
                                <li>
                                    Collect sensitive information (e.g., health, payment data) without our consent, as needed.
                                </li>
                                <li>
                                    Violate intellectual property, privacy, or other rights of us or third parties, as needed.
                                </li>
                                <li>
                                    Export the Services or Software in violation of U.S. export controls, as needed.
                                </li>
                            </ul>
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            5.2. User Equipment
                        </Typography>
                        <Typography paragraph>
                            You are responsible for your devices, internet access, and safety while using the Services or attending Events, as needed. We are not liable for issues arising from your equipment or Event attendance, as needed.
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            5.3. General Practices Regarding Use and Storage**
                        </Typography>
                        <Typography paragraph>
                            We may establish general practices and limits for the Services, including the maximum time that data or content (e.g., Event listings, Attendee information) may be retained and the maximum storage space allocated on our or our third-party providers’ servers, as needed. You agree that we are not responsible or liable for the deletion or failure to store any data or content maintained or uploaded to the Services, as needed. We reserve the right to terminate accounts inactive for an extended period, notifying you via your registered email or support@nrby.io , as needed. We may change these practices or limits at any time, with or without notice, as needed.
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            5.4. Beta Features
                        </Typography>
                        <Typography paragraph>
                            Certain features of the Services, or the Services themselves, may be offered in “beta” form (“Beta Features”), identified as “beta,” “pilot,” “limited release,” or similar, as needed. Participation is at your discretion. Beta Features are provided “as is” and “as available,” without warranties, and we are not liable for any damages, costs, or issues arising from their use, including internet access fees, backup expenses, device damage, or data loss, as needed. You assume all risks and costs associated with Beta Features, as needed. We are not obligated to provide maintenance, technical, or other support for Beta Features and may modify or discontinue them at any time, with or without notice, as needed.
                        </Typography>

                        <Typography variant="h5" gutterBottom mt={4}>
                            6. Events and Transactions
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            6.1. Organizer Responsibilities
                        </Typography>
                        <Typography paragraph>
                            If you are an Organizer, you agree to, as needed:
                            <ul>
                                <li>
                                    Obtain all necessary licenses, permits, and authorizations for your Events before selling tickets.
                                </li>
                                <li>
                                    Ensure Events and listings comply with U.S. laws, regulations, venue rules, and our Community Guidelines.
                                </li>
                                <li>
                                    Deliver Events as described, ensuring accuracy and safety, as needed.
                                </li>
                                <li>
                                    Honor ticketing and refund commitments per the Organizer Agreement.
                                </li>
                                <li>
                                    Verify Attendee identities and ticket validity using our tools, as needed.
                                </li>
                                <li>
                                    Accept responsibility for chargebacks, fraud, or disputes related to your Events, reimbursing us for all related expenses (e.g., chargeback amounts, legal fees, fines), per the Organizer Agreement, as needed.
                                </li>
                            </ul>
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            6.2. Attendee Responsibilities
                        </Typography>
                        <Typography paragraph>
                            If you are an Attendee, you agree to, as needed:
                            <ul>
                                <li>
                                    Provide accurate information when registering or purchasing tickets.
                                </li>
                                <li>
                                    Use tickets only for the intended Event, discarding refunded tickets to prevent fraud.
                                </li>
                                <li>
                                    Comply with Event and venue rules, understanding entry is at their discretion, as needed.
                                </li>
                                <li>
                                    Assume inherent risks of attending Events (e.g., injury, illness), participating voluntarily.
                                </li>
                            </ul>
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            6.3. Payments and Fees
                        </Typography>
                        <Typography paragraph>
                            <ul>
                                <li>
                                    Fees: Accessing the Services is free, but we charge fees for paid tickets, as needed, displayed at checkout. Organizers decide whether fees are passed to Attendees or absorbed. Fees may include taxes, processing, or fulfillment charges. Bank or card fees are your responsibility, as needed.
                                </li>
                                <li>
                                    Payments: Attendees must use the payment method selected by the Organizer. We may act as the Organizer’s agent to process payments via third-party providers (e.g., Stripe), as needed.
                                </li>
                                <li>
                                    Confirmations: Upon order confirmation, we send a unique confirmation number and email. Organizers must honor confirmed orders, as needed.
                                </li>
                            </ul>
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            6.4. Refunds and Transfers
                        </Typography>
                        <Typography paragraph>
                            <ul>
                                <li>
                                    Refunds: Transactions are between Organizers and Attendees. Orders/tickets are <strong>non-refundable</strong> with the exception of canceled, non-occurring, or materially changed Events, per applicable laws, as needed. Contact the Organizer with questions; escalate to support@nrby.io if unresolved, as needed. Our fees are non-refundable unless required by law.
                                </li>
                                <li>
                                    Transfers: Ticket transfers depend on Organizer policies. Contact the Organizer or us at support@nrby.io, as needed.
                                </li>
                                <li>
                                    Fraud Prevention: Using a refunded ticket is fraud. We are not liable for costs from invalid tickets or third-party purchases, as needed.
                                </li>
                            </ul>
                        </Typography>

                        <Typography variant="h5" gutterBottom mt={4}>
                            7. Content and Intellectual Property
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            7.1. Site Content
                        </Typography>
                        <Typography paragraph>
                            All content on the Services (e.g., text, images, logos, Software), except User Content, is owned by us or our licensors (“Site Content”) and protected by U.S. copyright, trademark, and other laws, as needed. Site Content is deemed “commercial computer software” per FAR 12.212 and DFAR 227.7202 for U.S. Government use, limited to these Terms, as needed.
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            7.2. Your Content
                        </Typography>
                        <Typography paragraph>
                            Content you upload or post (e.g., Event listings, photos, comments) is “Your Content.” You:
                            <ul>
                                <li>
                                    Retain ownership but grant us a non-exclusive, worldwide, perpetual, royalty-free, transferable, sublicensable license, as needed, to use, reproduce, modify, display, and distribute Your Content to operate and promote the Services (e.g., featuring your Event in marketing).
                                </li>
                                <li>
                                    Represent that Your Content is accurate, lawful, and does not infringe third-party rights, as needed.
                                </li>
                                <li>
                                    Acknowledge we may remove Your Content for violations of these Terms, Community Guidelines, or at our discretion, as needed.
                                </li>
                            </ul>
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            7.3. Trademarks
                        </Typography>
                        <Typography paragraph>
                            Our trademarks and logos (“Nrby Events Trademarks”) are our property. Third-party trademarks are owned by their respective owners. You may not use trademarks without prior written consent, as needed.
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            7.4. Copyright Complaints
                        </Typography>
                        <Typography paragraph>
                            If you believe content infringes your copyright, submit a Digital Millennium Copyright Act (DMCA) notice per our Trademark and Copyright Policy at www.nrbyevents.com/copyright, as needed.
                        </Typography>

                        <Typography variant="h5" gutterBottom mt={4}>
                            8. Communications
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            8.1. Contact Methods
                        </Typography>
                        <Typography paragraph>
                            By using the Services, you consent to be contacted by Nrby Events, its affiliates, or partners via email, SMS, MMS, or push notifications, as needed, for:
                            <ul>
                                <li>
                                    Account updates, transaction confirmations, or support.
                                </li>
                                <li>
                                    Event updates, ticket updates, event cancellations, or any event related messaging.
                                </li>
                                <li>
                                    Marketing, if you opt in (opt out via “STOP” for SMS/MMS, unsubscribe links for email, or device settings for notifications), as needed.
                                </li>
                            </ul>
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            8.2. Text Messaging
                        </Typography>
                        <Typography paragraph>
                            You consent to receive text messages, SMS, or MMS for marketing, informational, or other purposes, even if your phone number is on the National Do Not Call List, a state Do Not Call List, or our internal Do Not Call List, as needed. To opt out, reply “STOP” to any text, SMS, or MMS message to cancel, or “HELP” for support, as needed. Canceling text communications may prevent access to certain Service features, and you agree to receive a final message confirming cancellation, as needed.
                            <ul>
                                <li>
                                    Costs: There is no additional charge from Nrby Events for text communications, but your carrier’s standard message and data rates apply, as needed. Your carrier may restrict features, and some features may be incompatible with your device. We are not liable for delays or failures in receiving text messages due to carrier transmission or device compatibility, as needed. Contact your carrier for plan-related questions.
                                </li>
                                <li>
                                    Compliance: Notify us at support@nrby.io if you change your phone number, as needed, to avoid liability under laws like the Telephone Consumer Protection Act.
                                </li>
                            </ul>
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            8.3. Electronic Communications
                        </Typography>
                        <Typography paragraph>
                            You consent to electronic communications, satisfying legal requirements for written notices, as needed. Communications are governed by our Privacy Policy (www.nrbyevents.com/privacy), as needed.
                        </Typography>

                        <Typography variant="h5" gutterBottom mt={4}>
                            9. Privacy
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            9.1. Data Handling
                        </Typography>
                        <Typography paragraph>
                            We handle your personal information per our Privacy Policy (www.nrbyevents.com/privacy), incorporated herein, as needed. Organizers must comply with applicable privacy laws when handling Attendee data, as needed.
                        </Typography>

                        <Typography variant="h5" gutterBottom mt={4}>
                            10. Confidentiality and Proprietary Rights
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            10.1. Proprietary Information
                        </Typography>
                        <Typography paragraph>
                            Each party (“Receiving Party”) may receive business, technical, or financial information from the other (“Disclosing Party”), including non-public details about the Services (“Proprietary Information”), as needed. The Receiving Party agrees to: 
                            <ul>
                                <li>
                                    Take reasonable precautions to protect Proprietary Information, as needed.
                                </li>
                                <li>
                                    Not use or disclose it to third parties, except to perform under these Terms, as needed.
                                </li>
                            </ul>
                            This obligation does not apply to information that, as needed:
                            <ul>
                                <li>
                                    Becomes publicly available without breach.
                                </li>
                                <li>
                                    Was known to the Receiving Party before disclosure.
                                </li>
                                <li>
                                    Is received from a third party without restriction.
                                </li>
                                <li>
                                    Is independently developed without using Proprietary Information.
                                </li>
                                <li>
                                    Must be disclosed by law.
                                </li>
                                <li>
                                    Protections lapse five years after disclosure, as needed.
                                </li>
                            </ul>
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            10.2. Ownership
                        </Typography>
                        <Typography paragraph>
                            We own all rights, title, and interest in the Services, Software, Site Content, and any derived data (e.g., analytics), subject to our Privacy Policy, as needed.
                        </Typography>

                        <Typography variant="h5" gutterBottom mt={4}>
                            11. Termination
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            11.1. Term
                        </Typography>
                        <Typography paragraph>
                            These Terms apply upon accessing the Services and continue until terminated, as needed.
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            11.2. Termination by Us
                        </Typography>
                        <Typography paragraph>
                            We may suspend or terminate your access, as needed, if you:
                            <ul>
                                <li>
                                    Violate these Terms, the Nrby Agreements, or applicable laws.
                                </li>
                                <li>
                                    Misuse the Services or engage in harmful conduct (e.g., fraud, spam).
                                </li>
                                <li>
                                    Fail to pay fees or reimburse chargebacks/fraud expenses (Organizers), as needed.
                                </li>
                                <li>
                                    Expose us to legal liability, as needed.
                                </li>
                                <li>
                                    We may terminate without cause at our discretion, notifying you unless doing so would prejudice you or us, as needed.
                                </li>
                            </ul>
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            11.3. Termination by You
                        </Typography>
                        <Typography paragraph>
                            You may stop using the Services or delete your account at www.nrbyevents.com/account, as needed. Ceasing access terminates these Terms, except for surviving provisions, as needed.
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            11.4. Effect of Termination
                        </Typography>
                        <Typography paragraph>
                            Upon termination, as needed:
                            <ul>
                                <li>
                                    All unpaid fees or reimbursements (e.g., chargebacks, fraud) become due.
                                </li>
                                <li>
                                    Your license to use the Services ends.
                                </li>
                                <li>
                                    Surviving provisions (e.g., Sections 4, 7-10, 12-16) remain in effect, as needed.
                                </li>
                            </ul>
                        </Typography>

                        <Typography variant="h5" gutterBottom mt={4}>
                            12. Disclaimers
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            12.1. No Warranties
                        </Typography>
                        <Typography paragraph>
                            The Services are provided “as is” and “as available,” as needed. To the fullest extent permitted by U.S. law, we disclaim all warranties, express or implied, including merchantability, fitness for a particular purpose, title, and non-infringement, as needed. We do not guarantee:
                            <ul>
                                <li>
                                    The Services will meet your expectations or be uninterrupted, secure, or error-free.
                                </li>
                                <li>
                                    Event quality, safety, or legality, or the accuracy of User-provided information.
                                </li>
                                <li>
                                    Results from using the Services will be accurate or reliable, as needed.
                                </li>
                                <li>
                                    Third-party acts or omissions (e.g., Organizers, venues), as needed.
                                </li>
                                <li>
                                    Events carry risks (e.g., injury, illness). You assume these risks voluntarily, as needed. Some jurisdictions limit disclaimers; only lawful limitations apply.
                                </li>
                            </ul>
                        </Typography>
                        <Typography variant="h5" gutterBottom mt={4}>
                            13. Limitation of Liability
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            13.1. Liability Cap
                        </Typography>
                        <Typography paragraph>
                            To the fullest extent permitted by U.S. law, Nrby Events, its affiliates, officers, directors, employees, agents, and licensors (“Nrby Events Parties”) will not be liable, as needed, for:
                            <ul>
                                <li>
                                    Indirect, incidental, special, consequential, punitive, or exemplary damages (e.g., loss of profits, data, business), even if advised of the possibility.
                                </li>
                                <li>
                                    Costs of substitute goods/services, data loss, or disruptions caused by third parties.
                                </li>
                                <li>
                                    Your Content, Event outcomes, chargebacks, fraud, or third-party actions, as needed.
                                </li>
                                <li>
                                    Our maximum aggregate liability is limited to the fees you paid us in the 12 months before the claim, or $100 if no fees were paid, as needed. This applies to all claims under any legal theory, except bodily injury. Some jurisdictions limit liability exclusions; only lawful limitations apply, as needed.
                                </li>
                            </ul>
                        </Typography>

                        <Typography variant="h5" gutterBottom mt={4}>
                            14. Dispute Resolution: Binding Arbitration and Class Action Waiver
                        </Typography>
                        <Typography paragraph>
                            PLEASE READ THIS SECTION CAREFULLY. It affects your rights, requiring most disputes to be resolved by binding arbitration, not court, and limiting class actions.
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            14.1. Informal Resolution
                        </Typography>
                        <Typography paragraph>
                            Before pursuing arbitration, you must contact support@nrby.io with a written description of the dispute, including your name, account email, issue details, and requested relief, as needed. We will attempt to resolve it within 60 days, tolling any statute of limitations, as needed.
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            14.2. Binding Arbitration
                        </Typography>
                        <Typography paragraph>
                            If informal resolution fails, disputes arising from these Terms, your use of the Services, or our relationship will be resolved by binding arbitration, as needed, except as noted in Section 14.3. Arbitration is conducted on an individual basis by a single arbitrator under the Federal Arbitration Act (FAA), administered by the American Arbitration Association (AAA) per its Consumer Arbitration Rules (www.adr.org), modified as follows:
                            <ul>
                                <li>
                                    Arbitrator Selection: AAA proposes candidates; we each strike up to three and rank the rest, with AAA selecting the highest-ranked, as needed.
                                </li>
                                <li>
                                    Location: For U.S. residents, arbitration occurs in your county of residence or by phone/video, at your choice. For claims under $10,000, it’s document-based unless a hearing is needed. Otherwise, arbitration is in Hennepin County, MN, unless burdensome, per AAA, as needed.
                                </li>
                                <li>
                                    Costs: We pay filing, administrative, and arbitrator fees for claims under $10,000, unless frivolous (you reimburse us if so). For higher claims, AAA rules apply, but we may cover excess costs if arbitration is costlier than court. Each party pays its own attorneys’ fees unless law allows otherwise, as needed.
                                </li>
                                <li>
                                    Award: The arbitrator’s decision is final, binding, and includes a reasoned explanation. Judgment may be entered in any court with jurisdiction, as needed. The arbitrator decides all issues, including arbitrability, scope, and enforceability, as needed.
                                </li>
                            </ul>
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            14.3. Exceptions
                        </Typography>
                        <Typography paragraph>
                            Arbitration does not apply to:
                            <ul>
                                <li>
                                    Intellectual property disputes (e.g., copyright, trademark), resolved in federal/state courts in Hennepin County, MN, as needed.
                                </li>
                                <li>
                                    Small claims court cases within jurisdictional limits, as needed.
                                </li>
                                <li>
                                    Requests for declaratory or equitable relief on statutes of limitations, which may be filed in court but stay arbitration, as needed.
                                </li>
                            </ul>
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            14.4. Class Action Waiver
                        </Typography>
                        <Typography paragraph>
                            You and we agree to arbitrate only on an individual basis, not as a class, consolidated, or representative action, except for batch arbitration (Section 14.5), as needed. The arbitrator may award relief only for your individual claim. If this waiver is unenforceable for a specific remedy, that remedy is severed and litigated in court, staying other claims until arbitration concludes, as needed.
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            14.5. Batch Arbitration
                        </Typography>
                        <Typography paragraph>
                            If 25 or more similar claims are filed within 90 days by the same or coordinated counsel, AAA will batch them (up to 50 per batch), as needed, with:
                            <ul>
                                <li>
                                    One arbitrator per batch.
                                </li>
                                <li>
                                    One set of fees per batch.
                                </li>
                                <li>
                                    Hearings in Hennepin County, MN, or by phone/video, per AAA.
                                </li>
                                <li>
                                    Sequential processing until all claims are resolved, as needed.
                                </li>
                                <li>
                                    You agree to cooperate to implement batching, tolling statutes of limitations, as needed.
                                </li>
                            </ul>
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            14.6. Opt-Out
                        </Typography>
                        <Typography paragraph>
                            You may opt out of arbitration and class action waivers by emailing support@nrby.io with “ARBITRATION OPT-OUT” in the subject line within 30 days of first using the Services or agreeing to these Terms, as needed. Include your name and account email. Opting out does not affect other Terms and applies mutually, as needed.
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            14.7. Survival
                        </Typography>
                        <Typography paragraph>
                            This Section 14 survives termination, as needed.
                        </Typography>

                        <Typography variant="h5" gutterBottom mt={4}>
                            15. Indemnification
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            15.1. Indemnity
                        </Typography>
                        <Typography paragraph>
                            You agree to indemnify, defend, and hold harmless the Nrby Events Parties from any claims, losses, damages, or expenses (including attorneys’ fees), as needed, arising from:
                            <ul>
                                <li>
                                    Your use or misuse of the Services.
                                </li>
                                <li>
                                    Your violation of these Terms, the Nrby Agreements, or applicable laws.
                                </li>
                                <li>
                                    Your User Content or infringement of third-party rights.
                                </li>
                                <li>
                                    Disputes with other Users or third parties (e.g., Organizers, venues), as needed.
                                </li>
                                <li>
                                    Any chargebacks, fraudulent activities, or related disputes (Organizers), as needed.
                                </li>
                                <li>
                                    We may assume control of any defense, and you will cooperate, as needed. For California residents, you waive California Civil Code Section 1542 regarding unknown claims, as needed.
                                </li>
                            </ul>
                        </Typography>

                        <Typography variant="h5" gutterBottom mt={4}>
                            16. General Terms
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            16.1. Governing Law and Jurisdiction
                        </Typography>
                        <Typography paragraph>
                            These Terms are governed by Minnesota law, without regard to conflict-of-law rules, as needed. Disputes not subject to arbitration will be resolved in state or federal courts in Hennepin County, MN, where you consent to jurisdiction and venue, as needed.
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            16.2. Entire Agreement
                        </Typography>
                        <Typography paragraph>
                            These Terms, with the Nrby Agreements, are the entire agreement between you and us, superseding prior communications, unless a separate written agreement signed by our authorized officer exists, as needed. No purchase order or similar form alters these Terms, as needed. 
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            16.3. Severability
                        </Typography>
                        <Typography paragraph>
                            If any provision is unenforceable, it will be limited to the minimum extent necessary, and other provisions remain in effect, as needed.
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            16.4. No Waiver
                        </Typography>
                        <Typography paragraph>
                            Our failure to enforce any right does not waive it, as needed. Remedies are cumulative.
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            16.5. Force Majeure
                        </Typography>
                        <Typography paragraph>
                            We are not liable for delays or failures due to acts of God, war, terrorism, strikes, or other events beyond our control, as needed.
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            16.6. No Assignment
                        </Typography>
                        <Typography paragraph>
                            You may not assign or transfer these Terms without our written consent, as needed. Any unauthorized assignment is void. We may assign our rights freely, as needed.
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            16.7. No Partnership
                        </Typography>
                        <Typography paragraph>
                            No agency, partnership, or joint venture is created by these Terms, as needed.
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            16.8. Feedback
                        </Typography>
                        <Typography paragraph>
                            Feedback you provide is non-confidential. You grant us a perpetual, royalty-free license to use it without compensation, as needed.
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            16.9. Third-Party Services
                        </Typography>
                        <Typography paragraph>
                            The Services may link to third-party websites or services (e.g., payment processors, Google Maps). We are not responsible for their availability, content, or practices. Your use is at your own risk, as needed.
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            16.10. Notices
                        </Typography>
                        <Typography paragraph>
                            Notices to you may be sent via email to your registered address or through the Services, as needed. Notices to us must be sent to:
                            <br/>Nrby Events, Inc.
                            <br/>Attn: Support Team
                            <br/>1161 Wayzata Blvd E., Suite 172
                            <br/>Wayzata, MN 55391
                            <br/>Email: support@nrby.io 
                            <br/>Notices are effective upon receipt, confirmed delivery, or the day after sending via recognized overnight service or certified mail, as needed
                        </Typography>
                        <Typography variant="h6" gutterBottom mt={4}>
                            16.11. Contact
                        </Typography>
                        <Typography paragraph>
                            For questions, contact us at support@nrby.io or the above address, as needed.
                        </Typography>
                    </Box>
                </Box>
            </Card>
        </MainLayout>
    );
};

export default TermsPage;
